// src/components/common/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const FooterWrapper = styled.footer`
  background-color: ${(props) => props.theme.colors.dark};
  color: ${(props) => props.theme.colors.white};
  padding: 3rem 0 1.5rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterColumn = styled.div`
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
`;

const FooterLink = styled.li`
  margin-bottom: 0.5rem;

  a {
    color: ${(props) => props.theme.colors.gray400};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
  text-align: center;
  color: ${(props) => props.theme.colors.gray400};
  font-size: 0.875rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  a {
    color: ${(props) => props.theme.colors.gray400};
    font-size: 1.25rem;
    transition: color 0.3s ease;

    &:hover {
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <FooterWrapper>
      <div className="container">
        <FooterGrid>
          <FooterColumn>
            <h3>İYİTAPU</h3>
            <p style={{ color: "#94A3B8", marginBottom: "1rem" }}>
              {t("footer.companyDescription")}
            </p>
            <SocialLinks>
              <a
                href="https://linkedin.com/company/iyitapu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="https://twitter.com/iyitapu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://instagram.com/iyitapu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://facebook.com/iyitapu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook"></i>
              </a>
            </SocialLinks>
          </FooterColumn>

          <FooterColumn>
            <h3>{t("footer.quickLinks")}</h3>
            <FooterLinks>
              <FooterLink>
                <Link to="/projects">
                  {t("navigation.projects")}
                </Link>
              </FooterLink>
              <FooterLink>
                <Link to="/construction-companies">
                  {t("navigation.constructionCompanies")}
                </Link>
              </FooterLink>
              <FooterLink>
                <Link to="/agents">{t("navigation.realEstateAgents")}</Link>
              </FooterLink>
              <FooterLink>
                <Link to="/apply">{t("navigation.apply")}</Link>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <h3>{t("footer.company")}</h3>
            <FooterLinks>
              <FooterLink>
                <Link to="/about">{t("footer.aboutUs")}</Link>
              </FooterLink>
              <FooterLink>
                <Link to="/faq">{t("footer.faq")}</Link>
              </FooterLink>
              {/*               <FooterLink>
                <Link to="/blog">{t("footer.blog")}</Link>
              </FooterLink> */}
              <FooterLink>
                <Link to="/contact">{t("footer.contact")}</Link>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <h3>{t("footer.legal")}</h3>
            <FooterLinks>
              <FooterLink>
                <Link to="/terms">{t("footer.termsOfService")}</Link>
              </FooterLink>
              <FooterLink>
                <Link to="/privacy">{t("footer.privacyPolicy")}</Link>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <h3>{t("footer.contactInfo")}</h3>
            <FooterLinks>
              <FooterLink>
                <a href="mailto:info@iyitapu.com">info@iyitapu.com</a>
              </FooterLink>
              <FooterLink>
                <a href="tel:+902125509005">+90 (212) 550 90 05</a>
              </FooterLink>
              <FooterLink>
                <address style={{ fontStyle: "normal", color: "#94A3B8" }}>
                  İçerenköy, Ofis Ataşehir, Kat 5<br />
                  Ataşehir/İstanbul
                </address>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>
        </FooterGrid>

        <FooterBottom>
          <p>{t("footer.copyright")}</p>
        </FooterBottom>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
